export default {
  "promoter": {
    "partnerId": 3440,
    "onelinkTemplateId": "589508454",
    "onelinkBaseUrl": "https://magazineluiza.onelink.me",
    "onelinkProductUrl": "https://www.magazineluiza.com.br",
    "onelinkOfferConfigs": {
      "afForceDeeplink": true,
      "isRetargeting": true,
      "pid": "magazinevoce",
      "productQueries": {
        "utmSource": "divulgador",
        "utmMedium": "magalu"
      }
    }
  },
  "logLevel": "error",
  "environment": "production",
  "cookieDomain": ".magazineluiza.com.br",
  "siteDomain": "https://m.magazineluiza.com.br",
  "platform": {
    "desktop": {
      "baseUrl": "https://www.magazineluiza.com.br",
      "cart": {
        "host": "https://sacola.magazineluiza.com.br"
      }
    },
    "mobile": {
      "baseUrl": "https://m.magazineluiza.com.br",
      "cart": {
        "host": "https://sacolamobile.magazineluiza.com.br"
      }
    }
  },
  "channel": {
    "mobile": {
      "id": "9",
      "name": "mixer.magazineluiza.com.br"
    },
    "desktop": {
      "id": "45",
      "name": "mixer-desk.magazineluiza.com.br"
    }
  },
  "otelEnabled": false,
  "datasource": {
    "graphql": {
      "host": "https://federation.magazineluiza.com.br",
      "timeout": 5000
    }
  },
  "shipping": {
    "timeout": 5000
  },
  "showcase": {
    "timeout": 5000
  },
  "review": {
    "mediaApi": "https://eufrazino-media-api.mglu.io",
    "timeout": 8000
  },
  "video": {
    "host": "https://ugc-content-prd.magalu.com"
  }
}
